"use client";

import React from "react";
import { ShieldCheck } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
const partners = [{
  name: "IATA",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642551/img/iata_logistics_logo.png"
}, {
  name: "FIATA",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642551/img/fiata_freight_logo.png"
}, {
  name: "COSEC",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642551/img/cosec_senegal_logo.png"
}, {
  name: "Port Autonome de Dakar",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642551/img/port_dakar_logo.png"
}, {
  name: "ISO 9001",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642551/img/certification_iso_9001.png"
}, {
  name: "WCA Network",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642551/img/wca_member_logo.png"
}, {
  name: "Customs Accredited",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642551/img/douanes_senegal_logo.png"
}];
export default function GlobalLogisticsPartners() {
  return <section data-section-id="222398" id="certifications-partenaires-trust-compliance" className="bg-muted text-foreground relative py-12 flex flex-col items-center justify-center overflow-hidden">
      <Separator className="absolute top-0 left-0 w-full bg-border/60" />

      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center space-y-8">
          
          <div className="w-full max-w-5xl mx-auto">
            <Carousel opts={{
            align: "center",
            loop: true,
            dragFree: true
          }} className="w-full">
              <CarouselContent className="-ml-4 md:-ml-8 items-center">
                {partners.map((partner, i) => <CarouselItem key={partner.name} data-index={i} className="pl-4 md:pl-8 basis-1/3 md:basis-1/4 lg:basis-1/5">
                    <div className="flex items-center justify-center h-16 group cursor-pointer">
                      <img src={partner.logo} alt={`${partner.name} logo`} className="max-h-8 max-w-[120px] object-contain grayscale opacity-50 transition-all duration-500 ease-out group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105" />
                    </div>
                  </CarouselItem>)}
              </CarouselContent>
            </Carousel>
          </div>

          <Badge variant="outline" className="border-border/50 bg-background/50 backdrop-blur-md text-primary py-1.5 px-4 gap-2 font-default tracking-widest uppercase text-[10px]">
            <ShieldCheck className="size-3.5 text-primary-foreground" />
            AGRÉÉ & CERTIFIÉ / APPROVED & CERTIFIED
          </Badge>
          
        </div>
      </div>

      <Separator className="absolute bottom-0 left-0 w-full bg-border/60" />
    </section>;
}